import React from 'react'
import ReactDOM from 'react-dom/client'
import { SpeedInsights } from '@vercel/speed-insights/react'
import App from './App'
import './index.css'


class ErrorBoundary extends React.Component {
  state = { hasError: false }
  static getDerivedStateFromError() {
    return { hasError: true }
  }
  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          padding: '1rem',
          textAlign: 'center',
          color: '#e8e6e3',
          background: '#0f0f12',
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          fontFamily: 'system-ui, sans-serif',
          fontSize: 'clamp(0.75rem, 4vw, 0.9rem)',
        }}>
          <p style={{ margin: 0 }}>Something went wrong.</p>
          <p style={{ margin: '0.5rem 0 0', opacity: 0.7 }}>Reload the page to try again.</p>
        </div>
      )
    }
    return this.props.children
  }
}

const root = document.getElementById('root')
if (root) {
  ReactDOM.createRoot(root).render(
    <React.StrictMode>
      <ErrorBoundary>
        <App />
        <SpeedInsights />
      </ErrorBoundary>
    </React.StrictMode>
  )
}
